function normalizeMediaKey(src = '') {
  const raw = String(src || '').trim();
  if (!raw) return '';
  let path = raw;
  try {
    path = new URL(raw, window.location.origin).pathname;
  } catch (e) {
    path = raw.split('?')[0].split('#')[0];
  }
  path = decodeURIComponent(path).split('?')[0].split('#')[0];
  path = path.replace(/^https?:\/\/[^/]+/i, '');
  path = path.replace(/^\/+/, '/');
  if (path.startsWith('/medienpool/')) return path;
  return path.replace(/^\/?medienpool\//, '/medienpool/');
}

export function getMediaMeta(overlay, src) {
  const key = normalizeMediaKey(src);
  if (!key) return null;
  const meta = overlay?.mediaMeta || {};
  return meta[key] || meta[key.replace(/^\/medienpool\//, '')] || null;
}

export function mediaAlt(overlay, src, lang = 'nl', fallback = '') {
  const meta = getMediaMeta(overlay, src);
  return meta?.alt?.[lang] || meta?.title?.[lang] || fallback || '';
}

export function mediaDescription(overlay, src, lang = 'nl', fallback = '') {
  const meta = getMediaMeta(overlay, src);
  return meta?.description?.[lang] || fallback || '';
}
